import { FC, ReactNode } from "react";
import { AppointmentAvatar } from "src/constants/icons";
import Avatar from "src/ui/components/Avatar/Avatar";
import {
  DefaultAvatar,
  GradientForm,
  GradientWrap,
  HostAvatarWrap,
  Picture
} from "./AppointmentDialog.styled";

const AppointmentHeroBanner: FC<{
  hostUserId?: string;
  avatarUrl?: string;
  avatarAlt?: string;
}> = ({ hostUserId, avatarUrl, avatarAlt }) => {
  let avatar: ReactNode;

  if (hostUserId) {
    avatar = (
      <HostAvatarWrap>
        <Avatar id={hostUserId} border={false} />
      </HostAvatarWrap>
    );
  } else if (avatarUrl) {
    avatar = <Picture src={avatarUrl} alt={avatarAlt} />;
  } else {
    avatar = (
      <DefaultAvatar>
        <AppointmentAvatar />
      </DefaultAvatar>
    );
  }

  return (
    <GradientWrap>
      <GradientForm />
      {avatar}
    </GradientWrap>
  );
};

export default AppointmentHeroBanner;
